import { type Order } from '@components/account/types'
import { formatDate } from '@helpers/utils'

export type OrderStatusProps = {
  status:
    | 'Cancelled'
    | 'Fulfilled'
    | 'Partially Fulfilled'
    | 'Oops'
    | 'In Progress'
    | 'Refunded'
  label: string
}

const getFulfillmentItemsCount = (fulfillments: Order['fulfillments']) => {
  let count = 0

  fulfillments.forEach(fulfillment => {
    count += fulfillment.fulfillmentLineItems.length
  })

  return count
}

export function getOrderStatus(
  fulfillments: Order['fulfillments'],
  lineItems: Order['lineItems'],
  cancelledAt?: Order['cancelledAt'],
  refunds: Order['refunds'] = []
): OrderStatusProps {
  if (cancelledAt) {
    return {
      status: 'Cancelled',
      label: `on ${formatDate(cancelledAt)}`
    }
  }

  if (refunds.length) {
    return {
      status: 'Refunded',
      label: `on ${formatDate(refunds[refunds.length - 1].createdAt)}`
    }
  }

  if (fulfillments.length === 0) {
    return {
      status: 'In Progress',
      label: 'We are on it'
    }
  }

  const trackingUrl =
    fulfillments?.[fulfillments.length - 1]?.trackingInformation?.[0]?.url

  if (getFulfillmentItemsCount(fulfillments) < lineItems.length) {
    return {
      status: 'Partially Fulfilled',
      label: trackingUrl ? 'Tracking Added' : 'Delivery in Progress'
    }
  }

  return {
    status: 'Fulfilled',
    label: trackingUrl ? 'Tracking Added' : 'Delivery in Progress'
  }
}
